// Central place for company details and links.
export const SITE = {
  brand: "AutoNeova",
  legalName: "AUTONEOVA LLC",
  tagline: "U.S.-based automotive e-commerce company",
  email: "autoneova@gmail.com",
  location: "United States",
  address: {
    line1: "30 N Gould St Ste 60241",
    city: "Sheridan",
    state: "WY",
    postalCode: "82801",
    country: "United States",
  },
  addressOneLine:
    "30 N Gould St Ste 60241, Sheridan, WY 82801, United States",
  website: "https://autoneova.com",
  amazonStore: "https://www.amazon.com/shops/autoneova",
  effectiveDate: "August 12, 2026",
  lastUpdated: "August 12, 2026",
};

export const NAV_LINKS = [
  { label: "Home", to: "/", testId: "nav-home-link" },
  { label: "About Us", to: "/about", testId: "nav-about-link" },
  { label: "Products", to: "/products", testId: "nav-products-link" },
  { label: "Contact", to: "/contact", testId: "nav-contact-link" },
];

export const CATEGORIES = [
  {
    slug: "wiper-blades",
    title: "Wiper Blades",
    description:
      "Front and rear wiper blades designed to support clear visibility and dependable wiping performance in different weather conditions.",
    image:
      "https://images.unsplash.com/photo-1747254780805-45ca5e592438?crop=entropy&cs=srgb&fm=jpg&w=800&q=70&ixlib=rb-4.1.0",
    alt: "Close-up of wiper blades resting on a car windshield",
  },
  {
    slug: "spark-plugs",
    title: "Spark Plugs and Ignition Products",
    description:
      "Spark plugs and selected ignition products for reliable engine starting and consistent combustion performance.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/80e4b78f-258e-4b0d-8981-5b21776858e6/images/0aff651c641278d3a25806ba420c1f3b3689661e7899ee504aabe7f6a0e5deba.jpeg",
    alt: "Automotive spark plugs and ignition components.",
  },
  {
    slug: "filters",
    title: "Filters",
    description:
      "Oil filters, cabin air filters and engine air filters for essential vehicle maintenance, filtration and protection.",
    image:
      "https://images.unsplash.com/photo-1588294020274-1e23a4815b72?crop=entropy&cs=srgb&fm=jpg&w=800&q=70&ixlib=rb-4.1.0",
    alt: "Automotive air filter element fitted in an engine bay",
  },
];

// Official brand logo assets stored locally in /public/brand-logos/.
export const BRANDS = [
  { name: "Bosch", slug: "bosch", logo: "/brand-logos/bosch.svg" },
  { name: "Valeo", slug: "valeo", logo: "/brand-logos/valeo.png" },
  { name: "MANN-FILTER", slug: "mann-filter", logo: "/brand-logos/mann-filter.svg" },
  { name: "FILTRON", slug: "filtron", logo: "/brand-logos/filtron.svg" },
];
